import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `MissionTrackerProvider` — the single integration point a host configures.
 *
 * The context plumbing (client construction, theme resolution, poll interval, the
 * rendered-outside-the-provider error) is `createDashboardContext` from `@cds/dashboard-kit`.
 * What stays here is the tracker's public prop shape, which is unchanged: a host still writes
 * `<MissionTrackerProvider baseUrl getToken onOpenMission theme>` exactly as before.
 *
 * The kit takes host callbacks in an `extra` object so its memo dependency list is a fixed
 * length; flattening that back into a plain `onOpenMission` prop is this wrapper's job, and it
 * is why the extraction did not change a single line of the five component files.
 */
import { useMemo } from 'react';
import { createDashboardContext } from '@cds/dashboard-kit';
import { TrackerClient } from './client.js';
const { Provider, useDashboard } = createDashboardContext({
    name: 'MissionTracker',
    createClient: (config) => new TrackerClient(config),
    // 30s — the same cadence the Barnyard bell has used. There is no push transport on this API.
    defaultPollIntervalMs: 30_000,
});
export function MissionTrackerProvider({ children, onOpenMission, ...config }) {
    const extra = useMemo(() => ({ onOpenMission }), [onOpenMission]);
    return (_jsx(Provider, { ...config, extra: extra, children: children }));
}
export const useTracker = useDashboard;
//# sourceMappingURL=provider.js.map